// Cầu nối để nút Lưu chung của màn hình bài khảo sát (surveyContext) gọi được
// hàm Lưu danh sách thành viên theo đơn vị nằm trong OrgUnitMemberProvider.

type SaveHandler = () => Promise<void>;

let saveHandler: SaveHandler | null = null;

export const registerOrgUnitMemberSave = (handler: SaveHandler) => {
  saveHandler = handler;
  return () => {
    if (saveHandler === handler) saveHandler = null;
  };
};

export const runOrgUnitMemberSave = async () => {
  if (saveHandler) await saveHandler();
};
